
<div *ngIf="loading || processingLogin"  class="dds__modal dds__loading-modal dds__d-block" tabindex="-1" role="dialog"  >
  <div class="dds__modal-dialog" role="document">
    <div class="dds__modal-content">
      <div class="dds__modal-body dds__text-center">
        <div class="dds__mb-3" id="modalId">
          <div class="dds__progress-bar">
            <div class="dds__progress-bar-standard dds__progress-bar-striped dds__progress-bar-animated"
              role="progressbar" data-showtext="true"></div>
          </div>
        </div>
        <p>Processing... Please wait.</p>
      </div>
    </div>
  </div>
</div>

<div *ngIf="!processingLogin">
  <mat-sidenav-container *ngIf="mode!='new_addition'">
  <mat-sidenav disableClose mode="side" opened="true">
    <mat-nav-list>
      <span *ngIf="RoleName==Moderator || RoleName==Publisher" class=" new" (click)="newFolder()"  matTooltip="New Folder" matTooltipPosition="right" aria-label="Description">
        <svg class="dds__svg-icons customSvg" aria-hidden="true">
          <use xlink:href="#dds__folder-add" />
        </svg>Create Folder
      </span>

      <span class="refresh" matTooltip="Refresh List" matTooltipPosition="right" aria-label="Description" (click)="refresh()">
        <svg class="dds__svg-icons customSvg" aria-hidden="true">
          <use xlink:href="#dds__refresh-spin" />
        </svg>
      </span>

    <div *ngIf="RoleName==Moderator || RoleName == Publisher" cdkDropListGroup>
      <app-menu-list-item *ngFor="let item of navItems" [item]="item"
      cdkDropList
      id="{{item.id}}"
      [cdkDropListData]="item.children"
      (cdkDropListDropped)="drop($event)"
      ></app-menu-list-item>
    </div>
    <div *ngIf="RoleName!=Moderator && RoleName!=Publisher">
      <app-menu-list-item *ngFor="let item of navItems" [item]="item"></app-menu-list-item>
    </div>

    </mat-nav-list>
  </mat-sidenav>
  <div class="container">
    <router-outlet></router-outlet>
  </div>
  </mat-sidenav-container>
</div>
